export default "__VITE_ASSET__DsKhLCg9__"